import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "email",
  "use": "email-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"email\">\r\n  <path d=\"M921.6 307.2l-409.6 256L102.4 307.2 102.4 204.8l409.6 256 409.6-256L921.6 307.2zM921.6 102.4 102.4 102.4C46.08 102.4 0 148.48 0 204.8l0 614.4c0 56.32 46.08 102.4 102.4 102.4l819.2 0c56.32 0 102.4-46.08 102.4-102.4L1024 204.8C1024 148.48 977.92 102.4 921.6 102.4z\" p-id=\"7475\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol